exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".bannersizevielkomplizierter .v-list__tile {\n  height: 110px !important;\n}\n.signaturinformation {\n  color: rgba(0,0,0,0.54);\n  font-family: 'Roboto', sans-serif;\n  display: inline-block;\n}\n", ""]);

